/*
 * @Author: hongye yanghongye@jtexpress.com
 * @Date: 2025-03-10 11:17:56
 * @Description: file content
 */
import { defineStore } from 'pinia'
import { useAuthStore } from "@/store"
import { isSuccess } from "@/utils"
import { commonService } from '@/service/api'
const getDictValue = async () => {
  return new Promise(async (resolve, reject) => {
    const res = await commonService.getDictValue({ dictCode: 'PRINT_GRAY' })
    if (!isSuccess(res)) return
    const str2 = ((res.data.records || []).find((_: any) => _.dictKey ==='returnStationCode') || {})?.dictValue || ''
    const authStore = useAuthStore()
    const { stationCode = '' } = authStore.userInfo
    let returnStationCodeIsGray = false
    if (str2 === 'ALL') {
      returnStationCodeIsGray = true
    } else if(stationCode) {
      returnStationCodeIsGray = str2.split(',').includes(`${stationCode}`)
    }
    resolve({
      returnStationCodeIsGray
    })
  })
}
// /orderParcel/printOrderConfig
const printOrderConfig = async () => {
  return new Promise(async (resolve, reject) => {
    const res = await commonService.printOrderConfig()
    console.log(res)
    if (!isSuccess(res)) return
    resolve(res.data || false)
  })
}
export const dictStore = defineStore('dict', {
  state: () => ({
    returnStationCodeIsGray: false,
    printGray: false
  }),
  actions: {
    getPrintGray() {
      return new Promise(async (resolve, reject) => {
        getDictValue().then((res: any) => {
          this.returnStationCodeIsGray = res.returnStationCodeIsGray as boolean
        })
      })
    },
    getPrintGraySync() {
      printOrderConfig().then((res: any) => {
        this.printGray = res as boolean
      })
    }
  },
  persist: {
    storage: localStorage
  }
})